import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import TextField from '@mui/material/TextField';

import withStyles from '@mui/styles/withStyles';

import { createStdRequest, apiFetch } from '../utils/utils';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    padding: '20px',
  },
  section: {
    marginTop: '24px',
  },
  scary: {
    color: 'red',
    fontWeight: 'bold',
    fontSize: '60px',
  },
  displayTd: {
    paddingLeft: '50px',
  },
});

class KimsExperimentPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userEmail: '',
      userPwd: '',
      pwdResponse: '',
      createSave1Sec: 0,
      createSave1Ms: 0,
      createSave50Sec: 0,
      createSave50Ms: 0,
      deleteViaEfSave1Sec: 0,
      deleteViaEfSave1Ms: 0,
      deleteViaEfSave50Sec: 0,
      deleteViaEfSave50Ms: 0,
      createViaDapperSec: 0,
      createViaDapperMs: 0,
      deleteViaDapperSec: 0,
      deleteViaDapperMs: 0,
      createNOutcome: '',
      deleteNOutcome: '',
      idOfAccountForDeletingRefCos: '0',
    };
  }

  showTestDbTable = false;
  showChangePasswordTable = false;
  showDeleteUnproductiveRefCosControls = true;

  stdMemoLabel = 'DeleteMe';

  submitNewPassword() {
    const uri = `/api/superAdmin/changePassword/email/${this.state.userEmail}/newPwd/${this.state.userPwd}`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      this.setState({ pwdResponse: json.message });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  createObjects(count, period) {
    const uri = `/api/superAdmin/createObjects/${count}/${period}`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      const { sec, ms } = json;
      if (period === 1) {
        this.setState({ createSave1Sec: sec, createSave1Ms: ms });
      } else {
        this.setState({ createSave50Sec: sec, createSave50Ms: ms });
      }
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  deleteObjects(method, count, period) {
    const uri = `/api/superAdmin/deleteObjects/${method}/${count}/${period}`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      const { sec, ms } = json;
      if (method === 'ef') {
        if (period === 1) {
          this.setState({ deleteViaEfSave1Sec: sec, deleteViaEfSave1Ms: ms });
        } else {
          this.setState({ deleteViaEfSave50Sec: sec, deleteViaEfSave50Ms: ms });
        }
      } else {
        this.setState({ deleteViaDapperSec: sec, deleteViaDapperMs: ms });
      }
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  createNAtOnce(n) {
    const uri = `/api/superAdmin/createNAtOnce/${n}`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      this.setState({ createNOutcome: json.message });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  deleteNAtOnce(n) {
    const uri = `/api/superAdmin/deleteNAtOnce/${n}`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      this.setState({ deleteNOutcome: json.message });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  enumerateUnproductiveRefCos() {
    const acctNo = this.state.idOfAccountForDeletingRefCos;
    console.log(`Hi there from enumerate function! account: ${acctNo}`);
    const uri = `/api/superAdmin/deleteUnproductiveRefCos/firmId/${acctNo}/justEnumerate`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      console.log(json.message);
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  enumerateNoRefButCommRefCos() {
    const acctNo = this.state.idOfAccountForDeletingRefCos;
    console.log(`Hi there from non-ref-but-outreached function! account: ${acctNo}`);
    const uri = `/api/superAdmin/deleteUnproductiveRefCos/firmId/${acctNo}/enumerateNonRefButOutreach`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      console.log(json.message);
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  deleteUnproductiveRefCos() {
    const acctNo = this.state.idOfAccountForDeletingRefCos;
    console.log(`Hi there from delete function! account: ${acctNo}`);
    const uri = `/api/superAdmin/deleteUnproductiveRefCos/firmId/${acctNo}/reallyDelete`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      console.log(json.message);
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    const { classes, userInfo } = this.props;
    const isSuperAdmin = userInfo.role === 'SuperAdmin';

    if (!isSuperAdmin) {
      return (
        <div className={classes.root}>
          <div className={classes.scary}>You don't belong here. Go Away!!!</div>
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <div>Welcome, Kim</div>
        {this.showChangePasswordTable && (
          <table className={classes.section}>
            <tbody>
              <tr>
                <td>User Email:</td>
                <td>
                  <TextField
                    variant="standard"
                    value={this.state.userEmail}
                    onChange={(event) => this.setState({ userEmail: event.target.value })}
                  />
                </td>
              </tr>
              <tr>
                <td>New Password:</td>
                <td>
                  <TextField
                    variant="standard"
                    value={this.state.userPwd}
                    onChange={(event) => this.setState({ userPwd: event.target.value })}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <button onClick={() => this.submitNewPassword()}>Submit</button>
                </td>
                <td>{this.state.pwdResponse}</td>
              </tr>
            </tbody>
          </table>
        )}
        {this.showTestDbTable && (
          <dev>
            <table className={classes.section}>
              <tbody>
                <tr>
                  <td>
                    <button onClick={() => this.createObjects(120, 1)}>Create 120 Objects, saving for each</button>
                  </td>
                  <td className={classes.displayTd}>
                    {this.state.createSave1Sec} sec, {this.state.createSave1Ms} ms
                  </td>
                </tr>
                <tr>
                  <td>
                    <button onClick={() => this.createObjects(120, 50)}>Create 120 Objects, saving for every 50</button>
                  </td>
                  <td className={classes.displayTd}>
                    {this.state.createSave50Sec} sec, {this.state.createSave50Ms} ms
                  </td>
                </tr>
                <tr>
                  <td>
                    <button onClick={() => this.deleteObjects('ef', 120, 1)}>
                      Delete 120 Objects Via EF, saving on each
                    </button>
                  </td>
                  <td className={classes.displayTd}>
                    {this.state.deleteViaEfSave1Sec} sec, {this.state.deleteViaEfSave1Ms} ms
                  </td>
                </tr>
                <tr>
                  <td>
                    <button onClick={() => this.deleteObjects('ef', 120, 50)}>
                      Delete 120 Objects Via EF, saving every 50
                    </button>
                  </td>
                  <td className={classes.displayTd}>
                    {this.state.deleteViaEfSave50Sec} sec, {this.state.deleteViaEfSave50Ms} ms
                  </td>
                </tr>
                <tr>
                  <td>
                    <button onClick={() => this.deleteObjects('dapper', 120, 50)}>
                      Delete 120 Objects Via Dapper, saving every 50
                    </button>
                  </td>
                  <td className={classes.displayTd}>
                    {this.state.deleteViaDapperSec} sec, {this.state.deleteViaDapperMs} ms
                  </td>
                </tr>
              </tbody>
            </table>

            <table className={classes.section}>
              <tbody>
                <tr>
                  <td>
                    <button onClick={() => this.createNAtOnce(100)}>Create 100 pairs of objects, saving once</button>
                  </td>
                  <td className={classes.displayTd}>{this.state.createNOutcome}</td>
                </tr>
                <tr>
                  <td>
                    <button onClick={() => this.deleteNAtOnce(100)}>Delete 100 pairs of objects, saving once</button>
                  </td>
                  <td className={classes.displayTd}>{this.state.deleteNOutcome}</td>
                </tr>
              </tbody>
            </table>
          </dev>
        )}
        {this.showDeleteUnproductiveRefCosControls && (
          <div>
            <div style={{ marginTop: '20px' }}>
              <button onClick={() => this.enumerateUnproductiveRefCos()}>
                Enumerate Unproductive RefCos for Account with FirmId:
              </button>
              &nbsp;&nbsp;
              <input
                value={this.state.idOfAccountForDeletingRefCos}
                onChange={(event) => this.setState({ idOfAccountForDeletingRefCos: event.target.value })}
              />
            </div>
            <div style={{ marginTop: '20px' }}>
              <button onClick={() => this.enumerateNoRefButCommRefCos()}>
                Enumerate Non-referring but Outreached RefCos for Account with FirmId:
              </button>
              &nbsp;&nbsp;
              <input
                value={this.state.idOfAccountForDeletingRefCos}
                onChange={(event) => this.setState({ idOfAccountForDeletingRefCos: event.target.value })}
              />
            </div>
            <div style={{ marginTop: '20px' }}>
              <button onClick={() => this.deleteUnproductiveRefCos()}>
                Delete Unproductive RefCos for Account with FirmId:
              </button>
              &nbsp;&nbsp;
              <input
                value={this.state.idOfAccountForDeletingRefCos}
                onChange={(event) => this.setState({ idOfAccountForDeletingRefCos: event.target.value })}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

KimsExperimentPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
});

const actionProducers = {};

export default connect(mapStateToProps, actionProducers)(withStyles(styles)(KimsExperimentPage));
